import React from 'react';
import { Checkbox } from 'semantic-ui-react'; 
import i18next from 'i18next';
import { Icon } from 'semantic-ui-react';
import {
  nth,
  getPaymentStatusText,
  paypalTotal,
  getPaymentStatus,
  tcStatus
} from '../../../common/utils';


// https://github.com/react-tools/react-table#columns
export const getColumns = (onSelect) => {
  return [
    nth,
    {
      Header: i18next.t('my:teams.tableHeaders.name'),
      accessor: 'name',
      maxWidth: 200
    },
    {
      Header: i18next.t('my:teams.tableHeaders.robotName'),
      accessor: 'robotName',
      maxWidth: 100
    },
    {
      Header: i18next.t('my:teams.tableHeaders.robotNumber'),
      accessor: 'robotNumber',
      maxWidth: 80,
      Cell: ({ original: o }) =>
        o.robotNumber ?  o.competition.code + '-' + o.robotNumber : ''
    },
    {
      Header: i18next.t('my:teams.tableHeaders.event'),
      id: 'eventTitle',
      accessor: 'event.title',
      maxWidth: 200
    },
    {
      Header: i18next.t('my:teams.tableHeaders.competition'),
      accessor: 'competition.i18n_title',
      maxWidth: 200,
      Cell: row => {
        const title = JSON.parse(row.original.competition.i18n_title); 
        return title[i18next.language];
      }
    },
    {
      id: 'memberCount',
      Header: () => <Icon name='user times'/>,
      accessor: row => row.members.length + '/' + (row.competition.teamMemberLimit || '-'),
      maxWidth: 40
    },
    {
      Header: i18next.t('my:teams.tableHeaders.pay'),
      sortable: false,
      maxWidth: 120,
      id: 'teamId',
      className: 'rtxCheckBoxTd',
      Cell: ({ original }) => {
        const status = getPaymentStatus(original);

        if (['NOT_PAID'].includes(status)) {
          return (
            <Checkbox
              label={i18next.t('my:teams.paySelect')}
              value={original.teamId}
              onChange={onSelect}
            />
          );

        } else {
          return <span>{getPaymentStatusText(original)}</span>;
        }
      }
    },
    paypalTotal,
    tcStatus
  ];
};

export const getNoDataText = () => {
  return i18next.t('my:teams.no_data');
};

export const DEFAULTSORTED = [
  { id: 'eventTitle', desc: true },
  { id: 'name', desc: false },
  { id: 'robotName', desc: false }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/user/components/Teams/table.conf.js